module.exports = __webpack_public_path__ + "static/media/Sky_Italia_-_Logo_2018.2bb9f403.png";